module.exports = __webpack_public_path__ + "static/media/whatsapp.fd9eb770.svg";